import { createSelector } from 'reselect'
import { immutableSelector } from 'utils/selectors'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import { unfilteredOrgUsersById, currentUser, currentOrgUsers, orgUsersLoaded } from 'app/modules/user/selectors'
import { UserStatus } from 'app/modules/user/constants'

import * as constants from './constants'

export const root = (state) => state.get('participants')

export const fetchStatus = createSelector(root, (root) => root.getIn(['status', 'fetch']))
export const addStatus = createSelector(root, (root) => root.getIn(['status', 'add']))
export const removeStatus = createSelector(root, (root) => root.getIn(['status', 'remove']))

export const currentConversationId = createSelector(root, (root) => root.getIn(['status', 'conversationId']))

export const isLoading = createSelector(fetchStatus, addStatus, removeStatus,
  (fetchStatus, addStatus, removeStatus) => {
    return addStatus === constants.ADD_PARTICIPANTS ||
           addStatus === constants.ADD_PARTICIPANTS_PENDING ||
           fetchStatus === constants.FETCH_PARTICIPANTS ||
           fetchStatus === constants.FETCH_PARTICIPANTS_PENDING ||
           removeStatus === constants.REMOVE_PARTICIPANTS ||
           removeStatus === constants.REMOVE_PARTICIPANTS_PENDING
  }
)

export const participantsLoaded = (conversationId) => createSelector(fetchStatus, currentConversationId, (fetchStatus, currentConversationId) => {
  return fetchStatus === constants.RECEIVE_PARTICIPANTS &&
         conversationId === currentConversationId
})

export const participants = createSelector(root, (root) => root.get('data'))

export const participantsOptionsLoaded = createSelector(participantsLoaded, orgUsersLoaded, (participantsLoaded, orgUsersLoaded) => participantsLoaded && orgUsersLoaded)

export const userParticipants = createSelector(unfilteredOrgUsersById, participants, (unfilteredOrgUsersById, participants) => {
  return participants
    .toList()
    .map(participantId => unfilteredOrgUsersById.get(participantId))
    .filter(Boolean)
    .filter(participant => !participant.bot)
    .sortBy(participant => getDisplayName(participant).toLowerCase())
})

export const participantsOptions = immutableSelector(
  userParticipants,
  currentOrgUsers,
  (userParticipants, currentOrgUsers) => {
    return currentOrgUsers
      .filter(user => !userParticipants.map(participant => participant.id).includes(user.id))
      .toJS()
      .map(user => ({ label: getDisplayName(user), value: user.id }))
  }
)

export const isCurrentUserParticipating = createSelector(
  participantsLoaded,
  participants,
  currentUser,
  (participantsLoaded, participants, currentUser) => {
    return participantsLoaded && participants.has(currentUser.id)
  }
)

export const isModalOpen = createSelector(root, (root) => root.get('ui'))



// WEBPACK FOOTER //
// ./src/scripts/app/modules/participants/selectors.js